import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import SmallForm from "../../components/form/small_form";
import { loadingState } from "../../recoil/loading.atom";
import DivStyle from "../../components/style/div.component";
import { FormProps } from "../../components/form/interface/formInterface";
import AdminAPI from "../../api/admin";

const GameInspectionSchedule = () => {
  const mode = "S";
  const setIsLoading = useSetRecoilState(loadingState);
  const [isInspection, setIsInspection] = useState<boolean>(false);
  const [endAt, setEndAt] = useState<string>("");

  const formData: FormProps = {
    title: "점검 시간",
    form: [
      {
        value: isInspection,
        setValue: setIsInspection,
        label: "점검 여부",
        type: "check",
        width: "100%",
      },
      {
        value: endAt,
        setValue: setEndAt,
        label: "종료 일시",
        type: "date",
        width: "100%",
      },
    ],
  };

  const save = async () => {
    setIsLoading(true);
    try {
      await AdminAPI.saveGameInspectionSchedule({
        isInspection,
        endAt,
      });
      alert("점검 시간이 설정되었습니다.");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const getGameInspectionSchedule = async () => {
    const res = await AdminAPI.getGameInspectionSchedule();
    if (res) {
      setIsInspection(res.isInspection);
      setEndAt(formatDate(res.endAt));
    }
  };

  useEffect(() => {
    getGameInspectionSchedule();
  }, []);

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          게임 점검 시간 설정
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            save={save}
            mode={mode}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default GameInspectionSchedule;
